<template>
  <div class="bottom">
    <div class="footer">
      <div class="footer-container">
        <div class="i-container">
          <div class="left">
            <div class="footer-title">国际物流</div>
            <div
              class="footer-item pointer"
              v-for="(item, index) in list"
              :key="index"
              @click="handleClick(index)"
            >
              {{ item.title }}/{{ item.en }}
            </div>
          </div>
          <div class="left">
            <div class="footer-title">联系我们</div>
            <div class="contact-info">服务热线： 18925901616</div>
            <div class="contact-info">
              联系邮箱： Cathy.jiang@fs-namucuo.com
            </div>
            <div class="contact-info">
              联系地址： 广东省佛山市顺德区伦教木工机械城22座4层407
            </div>
          </div>
          <div class="left">
            <div class="footer-title">关注公众号</div>
            <img src="../assets/qrcode.gif" class="qrcode" />
          </div>
        </div>
      </div>
    </div>
    <div class="copy-info">
      <div>
        Copyright ©佛山市纳木措国际货运代理有限公司,Inc.All rights reserved.
      </div>
      <div>Copy right Foshan Namucuo International Logistics CO;LTD</div>
      <a href="https://beian.miit.gov.cn/">粤ICP备19108848号</a>

      <div style="width:300px;margin:0 auto; padding:20px 0;">
        <a
          target="_blank"
          href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=44060602002178"
          style="display:inline-block;text-decoration:none;height:20px;line-height:20px;"
          ><img src="@/assets/beian.png" style="float:left;" />
          <p
            style="float:left;height:20px;line-height:20px;margin: 0px 0px 0px 5px; color:#939393;"
          >
            粤公网安备 44060602002178号
          </p></a
        >
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Footer",
  props: {
    list: {
      type: Array,
      default() {
        return [];
      }
    }
  },
  methods: {
    handleClick(index) {
      // this.$emit("choose", index);
    }
  }
};
</script>

<style scoped>
.i-container {
  display: flex;
}
.copy-info {
  width: 100%;
  text-align: center;
  margin-top: 10px;
  padding-bottom: 10px;
}
/* .pointer {
  cursor: pointer;
} */
.contact-info {
  font-size: 14px;
  line-height: 30px;
  width: 450px;
  text-align: start;
}
.left {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  margin-right: 100px;
}
.footer {
  background: url("../assets/foot_bg.jpeg") no-repeat top center;
  justify-content: space-around;
  height: 280px;
  /* width: 100vw; */
  color: white;
  display: flex;
  align-items: center;
  margin: 0 auto;
}
.footer-title {
  font-size: 22px;
  font-weight: 700;
  margin-bottom: 20px;
}
.footer-item {
  font-size: 14px;
  line-height: 30px;
  border-bottom: 1px dotted #ccc;
  /* width: 250px; */
  text-align: start;
}
.footer-container {
  display: flex;
  justify-content: space-around;
  width: 100%;
}
.bottom {
  background-color: white;
}
</style>



// WEBPACK FOOTER //
// src/components/Footer.vue